export abstract class DateTimeProvider {
  abstract now(): Date;
}

export class SystemDateTimeProvider extends DateTimeProvider {
  public now(): Date {
    return new Date();
  }
}
